import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ball-pulse',
  templateUrl: './ball-pulse.component.html',
})
export class BallPulseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
